import pako from 'pako';

export default function decodeGzip(base64Str) {
  if (!base64Str) return null;

  base64Str = base64Str.replaceAll('-', '+').replaceAll('_', '/');

  const pad = base64Str.length % 4;
  if (pad) base64Str += '='.repeat(4 - pad);

  try {
    const binaryString = atob(base64Str);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.codePointAt(i);
    }
    const decompressed = pako.ungzip(bytes, { to: 'string' });
    return decompressed;
  } catch (err) {
    throw new Error(
      'Failed to decompress gzip with pako: ' +
        (err?.message ?? err),
    );
  }
}

